import { Component, OnInit, ViewChild } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { CanonicalService } from '../../shared/canonical.service';

function ValidateEmail(control:AbstractControl):{[key:string]:Boolean}|null{  
      
  // let regularExp = /^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|yahoo|outlook)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
  let regularExp = /^([\w.-]+)@((?!hotmail|gmail|yahoo|outlook)([a-zA-Z\d-]+\.)+)([a-zA-Z]{2,4}|\d{1,3})(\]?)$/;
    
      if(control.value!==undefined && !regularExp.test(control.value)){  
        return {"isValidEmail":true};  
      }  
      return null;  
  }  

@Component({
  selector: 'app-rasp',
  templateUrl: './rasp.component.html',
  styleUrls: ['./rasp.component.css']
})
export class RaspComponent implements OnInit {

  @ViewChild('closebutton') closebutton: any;
  subscribeForm: FormGroup;
  demoForm: FormGroup;
  public message: any;
  cilentIPAddress = '';
  demoSubmitted = false;
  submittedSub = false;
  innerWidth:number = window.innerWidth;
  currentRoutePath: any;
  heading = "In-App Security for Mobile Apps";
  subheading = "Runtime Application Self Protection (RASP) for Mobile Apps In-App Protection";

  slides = [
    {img: "http://placehold.it/350x150/000000"},
    {img: "http://placehold.it/350x150/111111"},
    {img: "http://placehold.it/350x150/333333"},
    {img: "http://placehold.it/350x150/000000"},
    {img: "http://placehold.it/350x150/111111"},
    {img: "http://placehold.it/350x150/333333"},
    {img: "http://placehold.it/350x150/666666"}
  ];
  slideConfig = {"slidesToShow": 4, "slidesToScroll": 1,"autoplay": true, "autoplaySpeed": 1500, "dots":true};

  addSlide() {
    this.slides.push({img: "http://placehold.it/350x150/777777"})
  }

  removeSlide() {
    this.slides.length = this.slides.length - 1;
  }

  slickInit() {
  }

  breakpoint() {
  }

  afterChange() {
  }

  beforeChange() {
  }

  slides1 = [
    {img: "assets/images/rasp/text-1.webp",text:"Debugger and Emulator Detection"},
    {img: "assets/images/rasp/text-2.webp",text:"Advance Deveice Binding"},
    {img: "assets/images/rasp/text-3.webp",text:"Pevention From Intent Hacking"},
    {img: "assets/images/rasp/text-4.webp",text:"Tap Jacking"},
    {img: "assets/images/rasp/text-5.webp",text:"Protection To Data At Rest"},
    {img: "assets/images/rasp/text-6.webp",text:"FRIDA and Hooking Detection"},
    {img: "assets/images/rasp/text-7.webp",text:"PROXY And VPN Detection"},
    {img: "assets/images/rasp/text-8.webp",text:"Network Sendboxing"},
    {img: "assets/images/rasp/text-9.webp",text:"Annual VAPT and Insurance"},

  ];
  slide1Config = {"slidesToShow": 4, "slidesToScroll": 1,"autoplay": true, "autoplaySpeed": 1500, "dots":true,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      // centerMode: true,

    }

  }, {
    breakpoint: 767,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
      dots: true,
      infinite: true,

    }
  },  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
    }
  }]
  };

  removeSlide1() {
    this.slides1.length = this.slides1.length - 1;
  }

  slick1Init() {
  }

  breakpoint1() {
  }

  afterChange1() {
  }

  beforeChange1() {
  }


  constructor(private titleService: Title,private metaTagService: Meta, private metaTagService1: Meta, public fb: FormBuilder, private http: HttpClient, private httpService: HttpService, private canonicalService: CanonicalService, public router: Router) { 

    this.canonicalService.setCanonicalURL("https://www.protectt.ai/rasp");
    this.currentRoutePath = this.router.url;
    this.httpService.getIPAddress().subscribe((res: any) => {
      this.cilentIPAddress = res.ip;
    });

    this.subscribeForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
    });
    this.demoForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]{1,64}@[a-z0-9.-]+\\.[a-z]{2,4}$'), ValidateEmail])],
      name: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.pattern('^[A-Za-z ]+$')])],
      designation: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
      message: [''],
      contactnumber: ['', Validators.compose([Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")])],
      company_name: ['', Validators.compose([Validators.required])],
      time_slot1: ['', Validators.compose([Validators.required])],
      time_slot2: ['', Validators.compose([Validators.required])],
    });

  }

  ngOnInit(): void {
    this.titleService.setTitle('Best Mobile App Security | RASP | In-App Security | Protectt.ai');
    this.metaTagService1.updateTag({name: 'title', content: 'Best Runtime Application Self Protection (RASP) for Mobile Apps | Protectt.ai'});
    this.metaTagService.updateTag(
      { name: 'description', content: 'Choose the latest mobile security app which secures your data in runtime applications from fraud, viruses, and much more. Protectt.ai protects your data and secures your digital payments. Schedule a Free Demo Now!'}
    );
  }

  submitDemoForm() {
    let dateString1 = this.demoForm.get('time_slot1')!.value;
    let dateString2 = this.demoForm.get('time_slot2')!.value;
    var dateTimeSlot1 = moment(dateString1).format('DD-MM-YYYY HH:MM');
    var dateTimeSlot2 = moment(dateString2).format('DD-MM-YYYY HH:MM');
    let url = environment.API_URL + "requestdemo";
    let urlValue = "";
    this.demoSubmitted = true;
    if (this.demoForm.invalid) {
      return;
    } else {
      if (url.includes("dev.website")) {
        urlValue = "nonprod"
      } else {
        urlValue = "prod"
      }
      var demoData = {
        email: this.demoForm.get('email')!.value,
        name: this.demoForm.get('name')!.value,
        designation: this.demoForm.get('designation')!.value,
        message: this.demoForm.get('message')!.value,
        contactnumber: this.demoForm.get('contactnumber')!.value,
        companyname: this.demoForm.get('company_name')!.value,
        timeslot1: dateTimeSlot1,
        timeslot2: dateTimeSlot2,
        ipaddress: this.cilentIPAddress,
        weburl: urlValue,
        adcampurl: this.currentRoutePath
      };
      let data = {
        salesLeadData: demoData,
      }
      let encryptMsg = JSON.stringify(data);
      let encMsg = this.httpService.encryptText(encryptMsg, HttpService.SECRET_KEY);
      let postData = {
        encryptedRequest: encMsg
      }

      this.httpService.postAPIMethod(url, postData).subscribe(
        res => {
          let decRes = this.httpService.decryptText(res, HttpService.SECRET_KEY);
          let decMsg = decRes;
          let resp: any = JSON.parse(decMsg);
          alert(resp['statusDesc']);
          // this.subRespData = JSON.parse(decMsg);
        },
        error => {
        });

      this.demoSubmitted = false;
      // alert("Request has been submitted..");
      this.closebutton.nativeElement.click();
    }
  }

  onReset() {

    this.message = '';
    this.demoForm.reset();
    this.subscribeForm.reset();
    this.demoSubmitted = false;
    this.submittedSub = false;
  }

  get getDemoForm() {
    return this.demoForm.controls;
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
